// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router/index'
import { store } from "./store/store.js";
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2';
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Vuelidate from 'vuelidate'
import VueBarcodeScanner from 'vue-barcode-scanner'

import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import miniToastr from 'mini-toastr'


Vue.use(Datetime)
Vue.prototype.$axios = axios;
Vue.prototype.$toast = miniToastr
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(VueFormWizard)
Vue.use(Vuelidate)
Vue.use(VueBarcodeScanner)


  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  };
miniToastr.init({types: toastTypes})
Vue.use(miniToastr);

Vue.component('v-select', vSelect)

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = 'token ' + token
}


export const bus = new Vue();



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})
